/**
 * CTMS / MyTasks / shared task status — Title Case wire values.
 */

import { createStatusHelpers } from "./statusHelpers";

export const CTMS_TASK_STATUS = {
  PENDING: "Pending",
  IN_PROGRESS: "In Progress",
  COMPLETED: "Completed",
} as const;

export type CtmsTaskStatus =
  (typeof CTMS_TASK_STATUS)[keyof typeof CTMS_TASK_STATUS];

const helpers = createStatusHelpers(
  CTMS_TASK_STATUS,
  CTMS_TASK_STATUS.PENDING,
  {
    PENDING: CTMS_TASK_STATUS.PENDING,
    IN_PROGRESS: CTMS_TASK_STATUS.IN_PROGRESS,
    COMPLETED: CTMS_TASK_STATUS.COMPLETED,
  },
);

export const CTMS_TASK_STATUS_VALUES = helpers.VALUES;
export const tryNormalizeCtmsTaskStatus = helpers.tryNormalize;
export const normalizeCtmsTaskStatus = helpers.normalize;
export const isCtmsTaskStatus = helpers.isStatus;
export const isAnyCtmsTaskStatus = helpers.isAnyStatus;
